var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"span3 skill"},[_c('h4',[_vm._t("default")],2),_c('div',{staticClass:"level"},[_c('span',{class:_vm.className()},[_vm._v(_vm._s(_vm.rankMessage()))])]),_c('p',[_vm._v(_vm._s(_vm.rankMessage()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }